module.exports = __webpack_public_path__ + "assets/img/b04cdf24dd7608a1966fd17ede2d23c4.svg";